import { toast } from "react-toastify";
import InvoicesRepository from "../../Repository/InvoicesRepository";
import { getInvoices, increaseInvoiceNo } from "./invoiceSlice";
import { Toast } from "../components/Toast";

export const deleteInvoice = async ({ id, dispatch }) => {
  try {
    let { data } = await InvoicesRepository.invoicesModel({
      request: {
        method: "deleteInvoice",
        data: {
          company_code: localStorage.getItem("companyCode"),
          _id: id,
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      toast.configure();
      toast.success("Invoice Deleted");
    } else {
      toast.configure();
      toast.error("Not Deleted");
      dispatch(getInvoices());
    }
  } catch (err) {
    toast.configure();
    toast.error("Error");
  }
};
export const createInvoice = async ({ invoice, dispatch, toggle }) => {
  console.log("invocie", invoice);
  
  try {
    let copy = JSON.parse(JSON.stringify(invoice));
    console.log("copyyy", copy);
  //  const itemsNumber =  copy.items.map((item,index)=> {
  //     return
  //   })
    copy.recieved = Number(copy?.recieved || 0);
    delete copy.invoiceNumber;
    let { data } = await InvoicesRepository.invoicesModel({
      request: {
        method: "saveInvoice",
        data: {
          company_code: localStorage.getItem("companyCode"),
          ...copy,
        },
      },
    });
    let msg = "Document already exists with this _id";
    let id = data.response.data.invoiceId;
    if (id && id != msg) {
      toggle();
      Toast("success", "Invoice Created");
    } else if (id == msg) {
      Toast("error", "Invoice No. Already exists");
      dispatch(increaseInvoiceNo());
    } else {
      Toast("error", "Invoice Not Created");
      dispatch(getInvoices());
    }
    return id;
  } catch (err) {
    Toast("error", "Error");
  }
};
